<template>
  <div>
    <div>
      <div
        class="modal fade show"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        v-if="workflowStore.renameModal"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">
                {{ this.workflowStore.modalData.title }}
                수정
              </h5>
            </div>
            <div class="modal-body">
              <div class="input-group">
                <!-- 일단 필요한 input, button v-if로 보여줌 (수정필요)-->
                <input
                  type="text"
                  class="form-control renameForm"
                  maxlength="21"
                  v-if="this.workflowStore.modalData.groupName != null"
                  v-model="workflowStore.modalData.groupName"
                />
<!--                  @keyup="checkName()"-->
                <input
                  type="text"
                  class="form-control renameForm"
                  v-if="this.workflowStore.modalData.workflowName != null"
                  v-model="workflowStore.modalData.workflowName"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary"
                style="background: #10948b"
                v-if="this.workflowStore.modalData.groupName != null"
                :disabled="workflowStore.modalData.groupName.length < 1"
                @click="updateGroup()"
              >
                저장
              </button>
              <button
                type="button"
                class="btn btn-primary"
                style="background: #10948b"
                v-if="this.workflowStore.modalData.workflowName != null"
                :disabled="workflowStore.modalData.workflowName.length < 1"
                @click="updateWorkflow()"
              >
                저장
              </button>
              <button
                type="button"
                class="btn btn-default"
                v-if="this.workflowStore.modalData.groupName != null"
                @click="showModal('rename', 'close')"
              >
                닫기
              </button>
              <button
                type="button"
                class="btn btn-default"
                v-if="this.workflowStore.modalData.workflowName != null"
                @click="showModal('rename', 'close')"
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Urls from "@/common/urls";
import Apiroot from "@/common/apiroot";
import eventbus from "@/store/modules/devEventBus";

export default {
  name: "renames",
  data() {
    return {};
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    },
  },
  methods: {
    showModal(tag, status) {
      var param = {};

      this.$store.dispatch("showModal", {
        params: param,
        tag: tag,
        status: status,
      });

      document.getElementsByClassName("overlay")[0].style.display = "none";
    },
    updateGroup() {
      const name = this.workflowStore.modalData.groupName.replace(
        /^\s+|\s+$/gm,
        ""
      );

      if (name == "" || name == null) {
        alert("폴더명을 입력해 주세요.");
      } else if (name == "홈") {
        alert("다른 폴더명을 입력해 주세요.");
      } else {
        var param = {
          groupCode: this.workflowStore.modalData.groupCode,
          groupName: name,
        };

        this.api.updateGroup(param)
        // this.$store
        //   .dispatch("postSend", {
        //     paths: Apiroot.group + Urls.updateGroup,
        //     params: param,
        //   })
          .then((res) => {
            console.log(res);

            this.api.getGroupList({ userCode: this.userStore.userCode })
            .then((ress)=>{
              console.log(ress)

              // this.$store.state.workflows.groups = ress.groups;

              eventbus.$emit("groupList")

              this.$store.dispatch("saveGroups", {groups : ress.groups})
            })

            this.showModal("rename", "close");
            alert("수정 되었습니다.");



          })
          .catch((error) => {
            console.log(error);
            alert("수정 실패하였습니다.");
          });
      }
    },
    updateWorkflow() {
      const name = this.workflowStore.modalData.workflowName;

      if (name.replace(/ /gi, "") == "" || name == null) {
        alert("workflow이름을 입력해 주세요.");
      } else {
        var param = {
          workflowCode: this.workflowStore.modalData.workflowCode,
          workflowName: name,
        };
        this.$store
          .dispatch("postSend", {
            paths: Apiroot.workflow + Urls.updateWorkflow,
            params: param,
          })
          .then((res) => {
            console.log(res);
            alert("수정 되었습니다.");
            this.showModal("rename", "close");
            var param = { userCode: this.userStore.userCode };
            this.$store.dispatch("getWorkflowList", {
              paths: Apiroot.workflow + Urls.getWorkflowList,
              params: param,
            });
          })
          .catch((error) => {
            console.log(error);
            alert("수정 실패하였습니다.");
          });
      }
    },
    checkName() {
      var len = 0;
      var name = this.addGroupName;

      for (var i = 0; i < name.length; i++) {
        if (escape(name.charAt(i)).length == 6) {
          len++;
        }
        len++;
      }

      if (len > 21) {
        console.log(name.substr(0, 21));
        this.$store.dispatch("changeWorkflowName", name.substr(0, 21));
      }
    },
  },
};
</script>
